<template>
  <!--订单信息-->
  <div>待开发</div>
</template>

<script>
export default {
  name: 'orderInfo'
}
</script>

<style scoped>

</style>
